import React from "react";
import PropTypes from "prop-types";
import Panel from "common/components/Panel";
import actions from "./actions";
import Resource from "src/common/components/Resource";
import FormFoodOrderingManagement from "./FormFoodOrderingManagement";

const handleSubmit = (id) => async (values, form) => {
  const { name, url } = values;
  const { setSubmitting, setErrors, setStatus } = form;
  try {
    await actions.update(id, { name, url });
    setStatus({ success: true });
  } catch (e) {
    setErrors({ http: e.message });
  }
  setSubmitting(false);
};

const EditFoodOrderingManagement = ({ match }) => (
  <Panel title="Edit Provider">
    <Resource
      name="food_supplier_master"
      resourceId={match.params.id}
      render={(data) => (
        <FormFoodOrderingManagement
          isEdit
          handleSubmit={handleSubmit(match.params.id)}
          initialValues={{ name: data.name || "", url: data.url || "" }}
        />
      )}
    />
  </Panel>
);

EditFoodOrderingManagement.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default EditFoodOrderingManagement;
